<template>
  <div class="contract-information-page pb60" v-loading.fullscreen.lock="fullscreenLoading">
    <Title currentPageTitle="运营报告审批申请"></Title>
    <!-- 申请信息 -->
    <div class="contract-base-box">
      <p class="contract-base-name">申请信息</p>
      <div class="contract-apply-box">
        <div class="contract-apply-item"><span>企业名称：</span>{{ formData.tenantName }}</div>
        <div class="contract-apply-item" v-show="isPlatformTask=='N'&&formData.organisationName"><span>组织名称：</span>{{ formData.organisationName }}</div>
        
      </div>
      <div class="contract-apply-box">
        <div class="contract-apply-item" v-show="isPlatformTask=='N'"><span>核算月：</span>{{ formData.accountMonth }}</div>
        <div class="contract-apply-item" ><span>账单周期：</span>{{ formData.billCycleList|billFilter }}</div>
        <!-- <div class="contract-apply-item"><span>关联质量考核流程：</span><span class="fontC-4fa1a4 c-pointer"
            @click="qualityDialogVisible = true">查看</span></div> -->
        <div class="contract-apply-item"><span>备注说明：</span>{{ formData.remarks ||'-' }}</div>
        <div class="contract-apply-item" v-show="formData.isContainServiceFee !== 'Y'&& isPlatformTask=='N'&&formData.researchReportType"><span>调研报告类型：</span>
          <span style="color: red;">{{codeTransformLable( formData.researchReportType ,getCodeListByKey('调研报告类型'))}}</span>
        </div>
      </div>
      <!-- 附件 -->
      <div class="contract-base-box">
        <div class="contract-apply-file">
          <span>运营报告：</span>
          <div>
            <el-upload class="upload-demo t-left" action="#" ref="createProject" 
              :on-preview="onPreview" :file-list="fileList" accept=".jpg,.jpeg,.png,.xlsx,.docx,.doc,.pdf"
              :auto-upload="true" :http-request="changeMainFile" :beforeUpload="beforeAvatarUpload">
              <div class="file-operate" slot="file" slot-scope="{ file }">
                <div class="file-name">{{ file.name }}</div>
                <div class="file-preview" @click=" handleMainRemove(file)">删除</div>
                <div class="file-preview" @click=" onPreview(file)">查看</div>
                <div class="file-preview" @click=" onDownload(file)">下载</div>
              </div>
              <div class="import-btn-tips">
                <el-button size="mini" icon="el-icon-my-import" type="importNew">导入文件</el-button>
                <div class="import-step-tip">当前支持上传jpg、jpeg、png、word、excel、pdf文件，单个文件大小≤{{ fileSize
                }}M</div>
              </div>
              <div v-if="reportUploading" class="report-upload-progress">
                <p class="report-upload-progress-text">{{ reportUploadProgressText }}</p>
                <el-progress color="#4fa1a4" :stroke-width="12" :percentage="reportUploadProgress"></el-progress>
              </div>
            </el-upload>

          </div>
        </div>
      </div>
      <div class="contract-base-box" style="padding-top: 0;padding-bottom:0">
        <div class="contract-apply-file">
          <span>付款单：</span>
          <div v-if="paymentData.relevanceList?.length">
            <div v-for="(item, index) in paymentData.relevanceList" :key="index">
              <div class="contract-apply-file mb10">
                {{ item.text || '-' }}
                <span v-if="item.guid" class="file-preview" @click="seeDetail(item.guid)">查看详情</span>
              </div>
            </div>
          </div>
          <span v-else>-</span>
        </div>
      </div>

    </div>
    <!-- <div class="contract-base-box">
      <p class="contract-base-name">开票说明</p>
      
    </div> -->
    <!-- 费用明细 -->
    <div class="contract-base-box">
      <p class="contract-base-name plan-detail">
        <span>费用明细</span>
        <el-button size="mini" type="info" @click="getPageDetail(1)">刷新</el-button>
      </p>
      <div class="back-color-fff content-main-box h100f">
        <el-table :data="tableData" stripe border style="width: 100%" max-height="50vh">
          <el-table-column label="序号" width="60" header-align="center" align="center" fixed="left">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
              <!-- {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }} -->
            </template>
          </el-table-column>
          <el-table-column prop="taskContentName" label="任务内容" show-overflow-tooltip header-align="center" align="left"
            width="200" fixed="left">
            <template slot-scope="scope">{{ scope.row.taskContentName || '-' }}</template>
          </el-table-column>
          <el-table-column prop="taskTotal" label="数量" show-overflow-tooltip header-align="center" align="right"
            width="130" fixed="left">
            <template slot-scope="scope">{{ scope.row.taskTotal || '-' }}</template>
          </el-table-column>
          <el-table-column prop="taskPrice" :label="formData.isContainServiceFee == 'Y' ? '单价(含服务费)' : '单价'"
            show-overflow-tooltip header-align="center" align="right" width="160" fixed="left">
            <template slot-scope="scope">{{ (scope.row.settlePercent ? '-' : scope.row.taskPrice) | numFmt | numDigit
            }}</template>
          </el-table-column>
          <el-table-column prop="taskPriceUnit" label="计价单位" show-overflow-tooltip header-align="center" align="left"
            width="100" fixed="left">
            <template slot-scope="scope">{{ scope.row.settlePercent ? '-' : scope.row.taskPriceUnit }}</template>
          </el-table-column>
          <el-table-column prop="taskAmount" label="金额(元)" show-overflow-tooltip header-align="center" align="right"
            width="160" fixed="left">
            <template slot-scope="scope">{{ scope.row.taskAmount | numFmt | numDigit }}</template>
          </el-table-column>
        </el-table>
        <div class="total_money_wrap">
          <div class="total-money-list">
            <span class="total-money-title">合计任务金额</span><span class="total-money-num">{{ formData.taskSumAmount | numFmt
              | numDigit }}</span>元
          </div>
          <div class="total-money-list" v-show="formData.isContainServiceFee !== 'Y' && isPlatformTask=='N'">
            <span class="total-money-title">平台运营服务费</span><span class="total-money-num">{{ formData.serviceFee | numFmt |
              numDigit }}</span>元
          </div>
          <div class="total-money-list" v-show="formData.isContainServiceFee !== 'Y'&& isPlatformTask=='N'&&formData.researchReportType">
            <span class="total-money-title">数据服务费</span
            ><span class="total-money-num">{{ formData.dataServiceFee | numFmt | numDigit }}</span>元
          </div>
          <div class="total-money-list" v-show="isPlatformTask=='N'">
            <span class="total-money-title">建议应付金额</span><span class="total-money-num">{{ formData.currentPayAmount |
              numFmt | numDigit }}</span>元
          </div>
        </div>
      </div>
    </div>
    <!-- 信息核对 -->
    <div class="contract-base-box">
      <p class="contract-base-name">信息核对</p>
      <el-row :gutter="24">
        <el-col :span="12" v-for="(item, index) in radioData" :key="index">
          <div class="contract-base-title" style="width:110px">
            <el-radio-group v-model="item.value" style="width:100px">
              <el-radio label="Y">是</el-radio>
              <el-radio label="N">否</el-radio>
            </el-radio-group>
          </div>
          <span class="contract-base-content"><span class="fontC-red">*</span>{{ item.name }}</span>
        </el-col>
      </el-row>
    </div>
    <!-- 流程 -->
    <div style="padding-left: 16px; background: #fff; margin-top: 4px">
      <iframe v-show="iframeSh" :src="srcs" class="iframe-sty"></iframe>
    </div>
    <!-- 提交 -->
    <div class="submit_btn_wrap">
      <el-button type="borderBlack" size="small" @click="$router.go(-1)">取消</el-button>
      <el-button type="importNew" size="small" @click="submitData(1)">提交申请</el-button>
    </div>
    <!-- <el-dialog title="查看关联的质量考核流程" :visible.sync="qualityDialogVisible" width="900px" top="15%">
      <div class="back-color-fff content-main-box h100f">
        <el-table :data="qualityList" style="width: 100%" height="60vh">
          <el-table-column prop="staffName" label="发起人" header-align="center" align="left" width="100">
            <template slot-scope="scope">{{ scope.row.staffName || '-' }}</template>
          </el-table-column>
          <el-table-column prop="tenantName" label="药企名称" header-align="center" align="left" width="160">
            <template slot-scope="scope">{{ scope.row.tenantName || '-' }}</template>
          </el-table-column>
          <el-table-column prop="organisationName" label="组织名称" header-align="center" align="left" width="160">
            <template slot-scope="scope">{{ scope.row.organisationName || '-' }}</template>
          </el-table-column>
          <el-table-column prop="accountMonth" label="核算月" header-align="center" align="left" width="90">
            <template slot-scope="scope">{{ scope.row.accountMonth || '-' }}</template>
          </el-table-column>
          <el-table-column prop="isPrecise" label="是否精准考核" header-align="center" align="left" width="100">
            <template slot-scope="scope">{{ scope.row.isPrecise == 'Y' ? '是' : '否' }}</template>
          </el-table-column>
          <el-table-column prop="peopleNum" label="人数" header-align="center" align="right" width="90">
            <template slot-scope="scope">{{ scope.row.peopleNum || 0 }}</template>
          </el-table-column>
          <el-table-column prop="totalMoney" label="考核总金额" header-align="center" align="right">
            <template slot-scope="scope">{{ scope.row.totalMoney | numDigit }}元</template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog> -->
    <ChoosePerson ref="choosePerson" :chooseTenantGuid="formData.tenantGuid"  :title=dialogTitle  @onSelect="onPersonSelect"></ChoosePerson>
  </div>
</template>
<script>
import { bpmnroute } from '@/api/apiRoute';
import Title from '@/components/title/title.vue';
import workFlowCommon from '@/uilt/workFlowCommon';
import ChoosePerson from './components/choosePersonOne';
export default {
  components: {
    Title,
    ChoosePerson,
  },
  data() {
    return {
      fileSize: 100,
      reportUploading: false,
      reportUploadProgress: 0,
      reportUploadProgressText: '',
      flowType: '00016',
      fullscreenLoading: false,
      rejectDialogVisible: false,
      passDialogVisible: false,
      qualityDialogVisible: false,//关联流程弹框
      approveSuggest: '',//审批意见
      isPlatformTask:'',//平台专属任务
      formData: {},
      tableData: [],//费用明细列表
      currentOrganisationName: '',
      //流程
      srcs: '',//流程地址
      processInstanceId: '',//流程id
      iframeSh: true,//流程显示
      currentStaffGuid: null, //当前登录人guid
      pageTable: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
      },
      //信息核对
      radioData: [
        { name: '任务总量与任务明细数量是否一致', value: null },
        { name: '任务总金额与任务明细金额是否一致', value: null },
        { name: '任务照片是否合理合规', value: null },
        { name: '会议资料是否齐全、真实', value: null },
        { name: '报告内容是否准确，无纰漏', value: null },
        { name: '报告是否格式美观，布局合理', value: null },
      ],
      personShow: false,
      // qualityList: [],//质量审批列表
      fileList: [],//文件列表
      dialogTitle:'选择人员',//弹框标题
      // dialogType:null,
      nodeList:[],//节点列表
      nodePersonList:[],//节点人员列表
      paymentData:{},//付款单详情
    };
  },
  filters: {
    billFilter(list) {
      let str='-'
      if(list&&list.length>0){
        str=list.join('、')
      }
      return str
    }
  },
  created() {
    let userinfo = JSON.parse(localStorage.userInfo);
    this.currentStaffGuid = userinfo.staffGuid;
    this.currentOrganisationName = userinfo.organisationName;
    if (this.$route.query.toType == 3) {
      this.radioData.forEach(i => {
        i.value = 'Y';
      })
    }
    this.getPageDetail();
    this.getFlowGuid();
  },
  methods: {
    seeDetail(guid) {
      // 付款单
      let url = '/downstreamPaymentDetail?guid=' + guid;
      window.open(url);
    },
    formatMoney(num) {
      // 将数字转换为字符串并保留两位小数
      num = num.toFixed(2);

      // 将字符串按小数点分割成整数部分和小数部分
      let parts = num.toString().split('.');

      // 将整数部分每三位加一个逗号
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

      // 将整数部分和小数部分拼接起来
      return parts.join('.');
    },
    /** 获取付款单详情 */
    async getPaymentData() {
      const relevanceList = this.formData.settleList.map((item) => {
        // 有可能没有核算月
        const accountMonthStr = item.accountMonth?.length
          ? JSON.parse(item.accountMonth).join("、")
          : "";
        const payableStr = item.payable ? this.formatMoney(item.payable) : "";

        return {
          ...item,
          text: `${item.applyStaffName} _ ${item.tenantName}${
            accountMonthStr ? ` _ ${accountMonthStr}` : ""
          }${payableStr ? ` _ ${payableStr}(元)` : ""}`,
        };
      });
      this.paymentData = {
        ...this.paymentData,
        relevanceList: relevanceList,
      };
    },
    codeTransformLable(val, list) {
      if (!val || !val.length) return '-';
      let result = [];
      if (typeof val == 'string') {
        list.forEach(item => {
          if (item.value == val) {
            result.push(item.text);
          }
        })
      } else {
        list.forEach(item => {
          val.forEach(el => {
            if (el == item.value) {
              result.push(item.text);
            }
          })
        })
      }
      return result.join('、');
    },
    //查看附件
    toSee(item, index) {
      let path = item.path;
      if (path.indexOf('.pdf' || '.PDF') > -1) {
        window.open(path);
      } else {
        window.open('https://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(path));
      }
    },

    //提交申请
    submitData(type) {
      // type为第几节点的提交
      let length=this.nodeList.length;
      try {
        if (!this.fileList || !this.fileList.length) {
          throw new Error(`请上传运营报告`);
        }
        // if (Number(this.formData.scoreCurrentPayAmount) <= 0 || !this.formData.scoreCurrentPayAmount) {
        //   throw new Error(`请输入应付金额`);
        // }
        this.radioData.forEach((item) => {
          if (!item.value) {
            throw new Error(`${item.name}不能为空`);
          }
          if (item.value !== 'Y') {
            throw new Error(`请完善${item.name}信息核对`);
          }

        });
      } catch (e) {
        this.$message.error(e.message);
        return;
      }
      //判断是否指定审批人
      // 增加节点，指定审批人选择了一个提交，再判断是否还需要指定审批人
      // personShow是否可以指定人，nodePersonList是选择人员的list
      if (this.personShow == true && this.nodePersonList.length<length  ) {
        this.dialogTitle='选择'+this.nodeList[type-1]+'节点人员';
        this.$refs.choosePerson.visible = true;
      } else {
        this.submitForm();
      }
    },
    //判断是否能指定最后节点的审批人
    isLastPerson(camundaDeploymentId) {
      let self = this;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/nodes/is-need-design?deploymentId=${camundaDeploymentId}`).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.personShow = res.data.data;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //获取指定人节点名称
    getNodeList(camundaDeploymentId) {
      let self = this;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/get-assigners-process-name?deploymentId=${camundaDeploymentId}`).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.nodeList = res.data.data||[];
          console.log('data', self.nodeList);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //指定人
    onPersonSelect([personGuid, data]) {
      let person=personGuid.join(',')
      if (!person) {
        this.$message.error('请先选择人员!')
        return;
      }
      console.log('person',person);
      this.nodePersonList.push(person)
      console.log('nodePersonList',this.nodePersonList);
      
      // 选择完人员之后不能直接提交，要判断所有节点都选了人之后才能提交接口
      // this.submitForm();
      this.submitData(this.nodePersonList.length+1);//第几个指定人的节点
    },
    // 提交调用
    submitForm() {
      let form = JSON.parse(JSON.stringify(this.formData));
      form.reportFile = []
      this.fileList.forEach(item => {
        form.reportFile.push({
          fileName: item.name,
          path: item.path
        })
      })
      //登录人信息
      form.currentTenantGuid = localStorage.guid;
      // 多节点审批
      form.startAssigner=this.nodePersonList[0]
      if(this.nodePersonList.length>1){
        form.startAssigners=this.nodePersonList.slice(1)
      }
      //判断重新提交
      if (this.$route.query.toType == 3) {
        form.bizApproveState = 'D';
      }

      form.scoreCurrentPayAmount = null;
      this.fullscreenLoading = true;
      this.api
        .postJson(`/${serverConfig.msSalesPerformService}/upstream/operation-report/submit`, form)
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message({
              message: messageConfig.SUBMIT_SUCCESS,
              type: 'success',
            });
            this.$router.go(-1);
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(() => {
          this.fullscreenLoading = false;
        });
    },
    //获取详情
    getPageDetail(type) {
      let self = this;
      let isUpdateFlag = type == 1 ? true : false;
      self.fullscreenLoading = true;
      self.api
        .get(`/${serverConfig.msSalesPerformService}/upstream/operation-report/detail?guid=${this.$route.query.guid}&isUpdateFlag=${isUpdateFlag}`)
        .then((res) => {
          self.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.formData = res.data.data;
            //平台专属
            self.isPlatformTask = self.formData.isPlatformTask;
            //费用明细
            self.tableData = self.formData.detailList;
            // 审批id
            self.approveGuid = self.formData.approveVO && self.formData.approveVO.approveGuid;
            //文件显示处理
            self.fileList = [];
            // self.getQualityList(self.formData);
            // self.isLastPerson(self.formData.approveVO.camundaDeploymentId);
            console.log(self.formData)
            if (self.formData.reportFile && self.formData.reportFile.length > 0) {
              self.formData.reportFile.forEach((i) => {
                let obj = {
                  name: i.fileName,
                  path: i.path,
                };
                this.fileList.push(obj);
                console.log(this.fileList)
              });
            }
            console.log('self',self.formData);
            if (self.formData.settleList.length) {
              self.getPaymentData()
            }
            
          } else {
            self.$message.error(res.data.msg);
          }
        }).catch(() => {
          self.fullscreenLoading = false;
        });
    },
    //获取关联质量审核数据
    // getQualityList() {
    //   let self = this;
    //   self.api
    //     .postJson(
    //       `/${serverConfig.msSalesPerformService}/quality-assessment/get-pass-list?organisationGuid=${self.formData.organisationGuid}&tenantGuid=${self.formData.tenantGuid}`, self.formData.qualityCheckGuidList
    //     )
    //     .then((res) => {
    //       if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
    //         self.qualityList = res.data.data || [];

    //       } else {
    //         self.$message.error(res.data.msg);
    //       }
    //     });
    // },
    //获取流程Guid
    getFlowGuid() {
      let self = this;
      let userInfo = JSON.parse(localStorage.userInfo);
      let req = {
        tenantGuid: localStorage.guid,
        flowType: this.flowType,
        staffGuid: userInfo.staffGuid,
      };
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/get-camunda-deployment-id`, req)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (res.data.data) {
              self.iframeSh = true;
              self.srcs =
                bpmnroute + '/iframeBpmn?camundaDeploymentId=' + res.data.data + '&token=' + localStorage.token;
              console.log(self.srcs);
              self.isLastPerson(res.data.data)
              self.getNodeList(res.data.data)
            } else {
              self.$message.error(messageConfig.FLOW_NO_ID);
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //上传限制

    handleExceed(files) {
      this.fileList.splice(1, 1);
      this.$message.warning(`当前限制选择 1 个文件`);
    },
    //上传限制
    beforeAvatarUpload(file) {
      const isLtMaxSizeM = file.size / 1024 / 1024 < this.fileSize;
      if (!isLtMaxSizeM) {
        this.$message({
          message: `上传文件大小不能超过 ${this.fileSize}MB!`,
          type: 'warning',
        });
      }
      return isLtMaxSizeM;
    },
    // 上传文件
    changeMainFile(file) {
      let self = this;
      const uploadItem = file.file;
      const fileTotal = uploadItem.size || 0;
      let formData = new FormData();
      formData.append('file', uploadItem);
      formData.append('fileName', uploadItem.name);
      
      // 显示进度条
      self.reportUploading = true;
      self.reportUploadProgress = 0;
      self.reportUploadProgressText = `正在上传 ${uploadItem.name}...`;

      return new Promise((resolve, reject) => {
        self.api
          .postImage(`/${serverConfig.msCommonAdminCloudService}/obs/upload-file-include-filename`, formData, {
            onUploadProgress: (progressEvent) => {
              const total = progressEvent.total || fileTotal;
              const loaded = progressEvent.loaded || 0;
              const percent = total ? Math.round((loaded / total) * 100) : 0;
              // 进度达到99%时保持，避免提前显示完成
              self.reportUploadProgress = percent >= 99 && total ? 99 : percent;
            },
          })
          .then((res) => {
            if (res.data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.error(res.data.msg || '上传失败,请重新上传!');
              reject(new Error(res.data.msg || '上传失败'));
              return;
            }
            self.reportUploadProgress = 100;
            self.fileList.push({
              name: uploadItem.name,
              path: res.data.data.data,
            });
            self.$message({
              message: '上传成功',
              type: 'success',
            });
            resolve(res);
          })
          .catch((err) => {
            self.$message.error('上传失败,请重新上传');
            reject(err);
          })
          .finally(() => {
            // 隐藏进度条
            setTimeout(() => {
              self.reportUploading = false;
              self.reportUploadProgress = 0;
              self.reportUploadProgressText = '';
            }, 500);
          });
      });
    },
    handleMainRemove(file) {
      this.fileList.forEach((item, index) => {
        if (item.path == file.path) {
          this.fileList.splice(index, 1);
        }
      });
    },
    onPreview(file) {
      var fileSuffix;
      if (file.name) {
        fileSuffix = file.name ? file.name.substring(file.name.lastIndexOf('.') + 1) : '';
      }
      if (file.fileName) {
        fileSuffix = file.fileName ? file.fileName.substring(file.fileName.lastIndexOf('.') + 1) : '';
      }

      if (fileSuffix === 'png' || fileSuffix === 'jpeg' || fileSuffix === 'jpg' || fileSuffix === 'pdf' || fileSuffix === 'zip' || fileSuffix === 'rar') {
        return window.open(file.path);
      }
      window.open('https://view.officeapps.live.com/op/view.aspx?src=' + file.path);
    },
    onDownload(file) {
      window.open(file.path + '?response-content-type=application/octet-stream');
    },
  },
};
</script>
<style scoped>
.file-operate {
  display: flex;
}

.file-preview {
  margin-left: 10px;
  cursor: pointer;
  text-decoration: underline;
  cursor: pointer;
  color: #4fa1a4;
}

.contract-information-page {
  overflow: auto;
}

.contract-base-box {
  position: relative;
  padding: 10px 16px;
  margin-top: 4px;
  background: #fff;
}

.contract-base-name {
  font-size: 16px;
  color: #212121;
  text-align: left;
  margin: 0 0 10px 0;
}

/* 申请信息 */
.contract-apply-box {
  display: flex;
  padding-left: 10px;
  margin-bottom: 10px;
}

.contract-apply-item {
  font-size: 14px;
  color: #666666;
  padding: 0 20px;
  box-sizing: border-box;
  border-right: 1px solid #e5e5e5;
}

.contract-apply-file {
  display: flex;
  font-size: 14px;
  color: #666666;
  padding: 0 16px;
  box-sizing: border-box;
  align-items: center;
}

.contract-file-inform {
  display: flex;
  align-items: center;
  margin-bottom: 23px;
}

.approve-img {
  position: absolute;
  top: 50px;
  right: 60px;
  width: 78px;
  height: 78px;
}

/* 合同信息 */
.contract-base-box .el-col-12 {
  display: flex;
  align-items: center;
  line-height: 22px;
  margin-bottom: 20px;
}

.el-col-12:nth-child(2n + 1) .contract-base-title {
  flex-shrink: 0;
  width: 250px;
  text-align: right;
  font-size: 14px;
  color: #666666;
}

.el-col-12:nth-child(2n) .contract-base-title {
  flex-shrink: 0;
  width: 290px;
  text-align: right;
  font-size: 14px;
  color: #666666;
}

.contract-base-content {
  color: #212121;
  text-align: left;
}

.contract-apply-item span:nth-child(2) {
  color: #4fa1a4;
  cursor: pointer;
}

/* 流程 */
.iframe-sty {
  width: 100%;
  height: 500px;
  border: none;
  /* background:grey; */
}

.select-task {
  color: #4fa1a4;
  text-decoration: underline;
  cursor: pointer;
}

.plan-detail {
  display: flex;
  justify-content: space-between;
}

.el-radio {
  margin-right: 10px;
}

.el-popover--plain {
  padding: 8px 20px;
}
</style>
